export const ELEMENT_COLORS: Readonly<Record<string, string>> = {
    C: '#909090',
    N: '#3050f8',
    O: '#ff3030',
    S: '#ffff30',
    H: '#ffffff',
    P: '#ff8000',
};
